import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../globals';

/**
 * Generated class for the ComponentsPopupsInviteFormModalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'components-popups-invite-form-modal',
    templateUrl: 'components-popups-invite-form-modal.html'
})
export class ComponentsPopupsInviteFormModalComponent {
    showInviteForm = false;
    invite = {
        restaurantName: '',
        responsibleName: '',
        contact: '',
    };

    constructor(
        private translate: TranslateService,
        private toastCtrl: ToastController,
        private viewCtrl: ViewController,
        private globals: Globals,
    ) { }

    dismissModal() {
        this.viewCtrl.dismiss();
    }

    async submitInviteForm() {
        const name = `${this.invite.responsibleName}, (${this.invite.restaurantName})`;
        const contact = this.invite.contact;
        const company = this.globals.restaurant.company;

        this.translate.get(`whatsapp-invite-message`, { company, name, contact }).subscribe((message: string) => {
            const encodedMessage = encodeURIComponent(message);
            const whatsappURL = `https://wa.me/34623104609?text=${encodedMessage}`;
            window.open(whatsappURL, '_blank');

            // Resetear y cerrar
            this.invite = { restaurantName: '', responsibleName: '', contact: '' };
            this.showInviteForm = false;

            // Toast opcional
            const toast = this.toastCtrl.create({
                message: this.translate.instant('invite-sent-confirmation'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        });

        this.dismissModal();
    }
}



// WEBPACK FOOTER //
// ./src/components/components-popups-invite-form-modal/components-popups-invite-form-modal.ts